import {useState} from "react";

import {
    LeasePackageCatalogTenantDto,
    ReplaceLeasePackageCatalogTenantsDto,
} from "../../model/LeasePackageCatalog";
import {customAxios} from "../customAxios";

export function useReplaceLeasePackageCatalogTenants() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<LeasePackageCatalogTenantDto[]>();
    const [error, setError] = useState<Error>();

    async function execute(id: number, dto: ReplaceLeasePackageCatalogTenantsDto) {
        try {
            setLoading(true);
            setError(undefined);
            const tenants = await replaceLeasePackageCatalogTenants(id, dto);
            setData(tenants);
            return tenants;
        } catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        } finally {
            setLoading(false);
        }
    }

    return {loading, data, error, execute};
}

export async function replaceLeasePackageCatalogTenants(
    id: number,
    dto: ReplaceLeasePackageCatalogTenantsDto,
): Promise<LeasePackageCatalogTenantDto[]> {
    const response = await customAxios.put<LeasePackageCatalogTenantDto[]>(
        `/v1/lease-package-catalogs/${id}/tenants`,
        dto,
    );
    return response.data;
}
